




















































import Vue from 'vue';

export default Vue.extend({
    name: 'trophy-case',
    methods: {
        cycleFonts() {
            this.$store.commit('cycleFonts');
        },
        cycleBackgrounds() {
            this.$store.commit('cycleBackgrounds');
        },
    },
    computed: {
        revealCounter(): number {
            return this.$store.state.revealCounter;
        },
    },
});
